export default Object.freeze({
    colorPrimary: '#D6001C',
    colorAccent: '#0cb04a',
});
